export const MACHINE = 'Machine';
//# sourceMappingURL=machine.js.map